import {useEffect, useState} from 'react';
import {isPhoneDevice} from '@utils/isPhoneDevice';

const useIsPhoneDevice = () => {
    const [isPhone, setIsPhone] = useState(false);

    useEffect(() => {
        setIsPhone(isPhoneDevice());
    }, []);

    return isPhone;
};

export default useIsPhoneDevice;
